var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "emap" } },
    [
      _c("NavBar"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.is_show_loading_text,
              expression: "is_show_loading_text"
            }
          ],
          staticClass: "msg-container"
        },
        [
          _c("div", { staticClass: "msg-mask" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-container" },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "18",
                  width: "2",
                  color: "white"
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("__emap.loading_text")) +
                    "\n            "
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.is_show_empty_text,
              expression: "is_show_empty_text"
            }
          ],
          staticClass: "msg-container empty"
        },
        [
          _c(
            "div",
            { staticClass: "text-container" },
            [
              _vm._l(_vm.empty_alert_list, function(product, index) {
                return _c("p", { key: index, staticClass: "text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(product.pane_text) +
                      "\n            "
                  )
                ])
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("__product_setting.no_data_and_no_release")) +
                    "\n            "
                )
              ])
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.is_show_favorites_hint
        ? _c("FavoritesHint", {
            staticClass: "favorites-hint",
            attrs: { favorites_hint_text: _vm.favorites_hint_text }
          })
        : _vm._e(),
      _vm._v(" "),
      Object.keys(_vm.kmap).length > 0
        ? _c("KXDMap", {
            ref: "kxdmap",
            attrs: {
              kmap: _vm.kmap,
              maptool_colorbars_list: _vm.maptool_colorbars_list,
              maptool_legends_list: _vm.maptool_legends_list,
              max_rain: _vm.is_show_unique_product_feature.max_rain,
              is_show_popup_table: _vm.is_show_popup_table,
              is_show_favorites: _vm.is_show_favorites
            },
            on: {
              "transfer-panes-config": _vm.assign_panes_config,
              change_favorites_hint_text: _vm.change_favorites_hint_text
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.is_show_unique_product_feature.vertical_product
        ? _c("VerticalRadar", {
            ref: "vertical_radar",
            attrs: {
              vertical_product:
                _vm.is_show_unique_product_feature.vertical_product
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "legends-content__wrapper" }, [
        _vm.is_loaded_monitor_message
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_show_unique_product_feature.monitor,
                    expression: "is_show_unique_product_feature.monitor"
                  }
                ],
                attrs: { id: "monitor_message" }
              },
              [
                _vm.check_in_maptool_legends_list("monitor")
                  ? [_vm._m(0)]
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.is_loaded_lightning_message
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_show_unique_product_feature.lightning,
                    expression: "is_show_unique_product_feature.lightning"
                  }
                ],
                attrs: { id: "lightning-message" }
              },
              [
                _vm.check_in_maptool_legends_list("lightning")
                  ? _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-content white--text" }, [
                        _c("p", [
                          _c("img", {
                            attrs: {
                              src:
                                "/static/images/product/lightning/3minCloudToGround.png"
                            }
                          }),
                          _vm._v(_vm._s(_vm.$t("__geojson.CG_last_3_mins")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("img", {
                            attrs: {
                              src:
                                "/static/images/product/lightning/3minCloudToCloud.png"
                            }
                          }),
                          _vm._v(_vm._s(_vm.$t("__geojson.IC_last_3_mins")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("img", {
                            attrs: {
                              src:
                                "/static/images/product/lightning/10minCloudToGround.png"
                            }
                          }),
                          _vm._v(_vm._s(_vm.$t("__geojson.CG_last_10_mins")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("img", {
                            attrs: {
                              src:
                                "/static/images/product/lightning/10minCloudToCloud.png"
                            }
                          }),
                          _vm._v(_vm._s(_vm.$t("__geojson.IC_last_10_mins")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("img", {
                            attrs: {
                              src:
                                "/static/images/product/lightning/30minCloudToGround.png"
                            }
                          }),
                          _vm._v(_vm._s(_vm.$t("__geojson.CG_last_30_mins")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("img", {
                            attrs: {
                              src:
                                "/static/images/product/lightning/30minCloudToCloud.png"
                            }
                          }),
                          _vm._v(_vm._s(_vm.$t("__geojson.IC_last_30_mins")))
                        ])
                      ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.is_loaded_typhoon_message
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_show_unique_product_feature.ty_track,
                    expression: "is_show_unique_product_feature.ty_track"
                  }
                ],
                attrs: { id: "typhoon-message" }
              },
              [
                _vm.check_in_maptool_legends_list("typhoon")
                  ? _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-content white--text" }, [
                        _c(
                          "p",
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "#ff0000", size: "16" } },
                              [
                                _vm._v(
                                  "\n                            icon-moderate-typhoon\n                        "
                                )
                              ]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm.$t("__geojson.typhoon_icon_text_severe")
                              ) + "\n                    "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "#22f7ff", size: "16" } },
                              [
                                _vm._v(
                                  "\n                            icon-moderate-typhoon\n                        "
                                )
                              ]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm.$t("__geojson.typhoon_icon_text_moderate")
                              ) + "\n                    "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "#e181f7", size: "16" } },
                              [
                                _vm._v(
                                  "\n                            icon-mild-typhoon\n                        "
                                )
                              ]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm.$t("__geojson.typhoon_icon_text_mild")
                              ) + "\n                    "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "#415ed3", size: "16" } },
                              [
                                _vm._v(
                                  "\n                            icon-typhoon\n                        "
                                )
                              ]
                            ),
                            _vm._v(
                              _vm._s(_vm.$t("__geojson.typhoon_icon_text_TD")) +
                                "\n                    "
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.is_show_unique_product_feature.traffic_live,
                expression: "is_show_unique_product_feature.traffic_live"
              }
            ],
            attrs: { id: "traffic-live" }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.check_in_maptool_legends_list("traffic_live"),
                    expression: "check_in_maptool_legends_list('traffic_live')"
                  }
                ],
                staticClass: "card"
              },
              [
                _c("div", { staticClass: "card-content white--text" }, [
                  _vm._v("\n                    即時路況"),
                  _c("br"),
                  _vm._v("\n                    順暢  ( >80km ): "),
                  _c("span", { staticClass: "line level_1" }),
                  _c("br"),
                  _vm._v("\n                    車多  (60~79km): "),
                  _c("span", { staticClass: "line level_2" }),
                  _c("br"),
                  _vm._v("\n                    車多  (40~59km): "),
                  _c("span", { staticClass: "line level_3" }),
                  _c("br"),
                  _vm._v("\n                    壅塞  (20~39km): "),
                  _c("span", { staticClass: "line level_4" }),
                  _c("br"),
                  _vm._v("\n                    嚴重壅塞(0~19km): "),
                  _c("span", { staticClass: "line level_5" }),
                  _c("br"),
                  _vm._v("\n                    道路封閉: "),
                  _c("span", { staticClass: "line level_-1" }),
                  _c("br"),
                  _vm._v("\n                    未取得資訊: "),
                  _c("span", { staticClass: "line level_no-data" }),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.traffic_live_display_time,
                          expression: "traffic_live_display_time"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        "\n                        最後更新時間: " +
                          _vm._s(_vm.traffic_live_display_time) +
                          "\n                    "
                      )
                    ]
                  )
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm.is_loaded_station_message
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_show_unique_product_feature.station,
                    expression: "is_show_unique_product_feature.station"
                  }
                ],
                attrs: { id: "station_message" }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.check_in_maptool_legends_list("station"),
                        expression: "check_in_maptool_legends_list('station')"
                      }
                    ],
                    staticClass: "card"
                  },
                  [
                    _c("div", { staticClass: "card-content white--text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("__gis.station"))
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "legend" }, [
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#2c7da8" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 0"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#2c8ca8" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 1"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#2ca8a8" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 2"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#41ab5d" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 3"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#74c476" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 4"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#b1edc1" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 5"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#c7e9b4" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 6"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#a50021" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 7"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#cc0000" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 8"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#ff4343" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 9"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#c800ff" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 10"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#df63d9" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 11"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend-item" }, [
                          _c("span", {
                            staticClass: "dot",
                            staticStyle: { background: "#fdafff" }
                          }),
                          _c("span", [
                            _vm._v(
                              "：" +
                                _vm._s(_vm.$t("__gis.beaufort_scale")) +
                                " 12"
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.is_loaded_gauge_message
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_show_unique_product_feature.gauge,
                    expression: "is_show_unique_product_feature.gauge"
                  }
                ],
                attrs: { id: "gauge_message" }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.check_in_maptool_legends_list("gauge"),
                        expression: "check_in_maptool_legends_list('gauge')"
                      }
                    ],
                    staticClass: "card"
                  },
                  [
                    _c("div", { staticClass: "card-content white--text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("__gis.auto_gauge_station"))
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "level_1" }, [_vm._v("●")]),
                      _vm._v(
                        " ： " +
                          _vm._s(_vm.$t("__gis.not_exceeding_heavy_rain"))
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "level_2" }, [_vm._v("●")]),
                      _vm._v(" ： " + _vm._s(_vm.$t("__gis.heavy_rain"))),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "level_3" }, [_vm._v("●")]),
                      _vm._v(
                        " ： " + _vm._s(_vm.$t("__gis.extremely_heavy_rain"))
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "level_4" }, [_vm._v("●")]),
                      _vm._v(" ： " + _vm._s(_vm.$t("__gis.torrential_rain"))),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "level_5" }, [_vm._v("●")]),
                      _vm._v(
                        " ： " +
                          _vm._s(_vm.$t("__gis.extremely_torrential_rain"))
                      ),
                      _c("br")
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "LegendColorBarSetting",
        _vm._b(
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.is_show_maptool,
                expression: "is_show_maptool"
              }
            ],
            on: { set_maptool_list: _vm.set_maptool_list }
          },
          "LegendColorBarSetting",
          _vm.show_map_setting_options,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom-dialog" },
        [
          Object.keys(_vm.need_display_alert_table_content).length !== 0
            ? _c("QpeAlertTable", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_show_alert_table && !_vm.is_show_popup_table,
                    expression: "is_show_alert_table && !is_show_popup_table"
                  }
                ],
                attrs: { props_alerts: _vm.need_display_alert_table_content }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.is_show_popup_table
            ? _c("PopupTable", {
                attrs: {
                  gis_popup_data: _vm.gis_popup_data,
                  gis_popup_type: _vm.gis_popup_type,
                  popup_type: _vm.popup_type,
                  description_info: _vm.description_info
                },
                on: {
                  "close-geojson-popup-table": _vm.clear_geojson_popup_data,
                  "close-gis-popup-table": _vm.clear_gis_popup_data,
                  "show-gis-diagram": _vm.show_wmarker_chart_dialog
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "diagram-dialog", style: _vm.css_props },
            [
              Object.keys(_vm.chart_options).length
                ? _c("GisChart", {
                    attrs: {
                      id: "belongs_emap_chart",
                      chart_options: _vm.chart_options,
                      default_variable: _vm.$t("__rainfall.rainfall")
                    },
                    on: { "close-chart-dialog": _vm.close_chart_dialog }
                  })
                : _vm._e(),
              _vm._v(" "),
              Object.keys(_vm.skew_options).length
                ? _c("SkewChart", {
                    attrs: { skew_options: _vm.skew_options },
                    on: { "close-chart-dialog": _vm.close_chart_dialog }
                  })
                : _vm._e(),
              _vm._v(" "),
              Object.keys(_vm.airplane_wind_chart_options).length
                ? _c("AirplaneWindChart", {
                    attrs: { chart_options: _vm.airplane_wind_chart_options },
                    on: { "close-chart-dialog": _vm.close_chart_dialog }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom-tool" },
        [
          _vm.timebar_option.list.length > 0
            ? _c("QpeTimeLine", {
                attrs: {
                  props_play_index: _vm.timebar_option.props_play_index,
                  list: _vm.timebar_option.list,
                  duration: _vm.timebar_option.duration,
                  latest_complete_data_timestamp:
                    _vm.timebar_option.latest_complete_data_timestamp,
                  is_show_loading_text: _vm.is_show_loading_text
                },
                on: {
                  "update:props_play_index": function($event) {
                    return _vm.$set(
                      _vm.timebar_option,
                      "props_play_index",
                      $event
                    )
                  },
                  "trigger-change-time": _vm.change_time
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: Object.keys(_vm.gis_popup_data).length,
            expression: "Object.keys(gis_popup_data).length"
          }
        ],
        staticClass: "point-tooltip",
        style: _vm.gis_icon_style,
        attrs: { src: "/static/images/product/gis/station.png" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.focal_sign_number,
              expression: "focal_sign_number"
            }
          ],
          staticClass: "table-sign point-tooltip",
          style: _vm.table_sign.style
        },
        [
          _vm._v("\n        " + _vm._s(_vm.focal_sign_number) + "\n        "),
          _vm.table_sign.icon_class
            ? _c("v-icon", { class: [_vm.table_sign.icon_class] }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.table_sign.signal_class) +
                    "\n        "
                )
              ])
            : _c("span", { staticClass: "table-sign__text" }, [
                _vm._v("\n            -\n        ")
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("AccumulatedPrecp", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.is_show_accumulated_precp_table && !_vm.is_monitor_open_emap,
            expression:
              "is_show_accumulated_precp_table && !is_monitor_open_emap"
          }
        ]
      }),
      _vm._v(" "),
      _vm.is_show_forecast_tool
        ? [
            _c(
              "VueDragResize",
              {
                attrs: {
                  "content-class": "typhoon-forecast-tooltip",
                  "drag-handle": ".drag",
                  "is-active": true,
                  "is-draggable": true,
                  "is-resizable": false,
                  w: 200,
                  h: 105,
                  x: _vm.typhoon_forecast_tooltip_initial_position.x,
                  y: _vm.typhoon_forecast_tooltip_initial_position.y
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "typhoon-forecast-title drag" },
                  [
                    _vm._v("\n                預測路徑工具\n                "),
                    _c(
                      "v-icon",
                      { staticClass: "drag", attrs: { color: "#b3b7c4" } },
                      [
                        _vm._v(
                          "\n                    icon-move\n                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "typhoon-forecast-control" },
                  [
                    _c("v-select", {
                      class: "typhoon-spd-select white--text",
                      attrs: {
                        items: _vm.typhoon_spd_select,
                        id: "typhoon-spd-select",
                        label: "播放速度",
                        "item-text": "text",
                        "item-value": "value"
                      },
                      on: { change: _vm.update_typhoon_loop_duration },
                      model: {
                        value: _vm.typhoon_loop_duration,
                        callback: function($$v) {
                          _vm.typhoon_loop_duration = $$v
                        },
                        expression: "typhoon_loop_duration"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: { color: "white" },
                            on: {
                              click: function($event) {
                                return _vm.set_typhoon_forecast_step("prev")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        mdi-rewind\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          ref: "typhoon_forecast_btn",
                          staticClass:
                            "typhoon-forecast-btn typhoon-forecast-btn-play",
                          class: { active: _vm.is_show_typhoon_animation },
                          on: {
                            click: function($event) {
                              return _vm.toggle_typhoon_animation()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          {
                            attrs: { color: "white" },
                            on: {
                              click: function($event) {
                                return _vm.set_typhoon_forecast_step("next")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        mdi-fast-forward\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-content white--text" }, [
        _vm._v("\n                        監控雨量"),
        _c("br"),
        _vm._v("\n                        預警值："),
        _c("span", { staticClass: "monitor_message--yellow" }, [_vm._v("●")]),
        _vm._v("\n                        警戒值："),
        _c("span", { staticClass: "monitor_message--orange" }, [_vm._v("●")]),
        _vm._v("\n                        行動值："),
        _c("span", { staticClass: "monitor_message--red" }, [_vm._v("●")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }